export default __webpack_public_path__ + "static/media/Trash.5f1629f5.svg";